module.exports = __webpack_public_path__ + "img/step1.b48f7816.png";